import "./Loader.css";
import loaderImg from "../../assets/loader-gif.gif";
const Loader = () => {
  return (
    <div className="overlay">
      <div className="flex justify-center items-center h-screen">
        <img src={loaderImg} alt="loader gif" />
      </div>
    </div>
  );
};

export default Loader;
